import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { EmployeeWageLedgerSearchSchema } from './-zod-schema';
export const Route = createFileRoute('/_staff/salary-and-wages/_layout/reports/$employeeId/wage-ledger')({
  validateSearch: zodValidator(EmployeeWageLedgerSearchSchema)
});